import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import TeamPage from "@/pages/TeamPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import AdminPage from "@/pages/AdminPage";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App bg-[#050505] text-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/inscripciones" element={<LandingPage scrollTo="inscripciones" />} />
          <Route path="/equipos/:slug" element={<TeamPage />} />
          <Route path="/politica-devoluciones" element={<RefundPolicyPage />} />
          <Route path="/politica-cookies" element={<CookiePolicyPage />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
